var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24606 14.0014C10.2126 14.0014 10.9961 14.7849 10.9961 15.7514V19.2514C10.9961 20.2179 10.2126 21.0014 9.24606 21.0014H3.75C2.7835 21.0014 2 20.2179 2 19.2514V15.7514C2 14.7849 2.7835 14.0014 3.75 14.0014H9.24606ZM20.25 14.0014C21.2165 14.0014 22 14.7849 22 15.7514V19.2514C22 20.2179 21.2165 21.0014 20.25 21.0014H14.7539C13.7874 21.0014 13.0039 20.2179 13.0039 19.2514V15.7514C13.0039 14.7849 13.7874 14.0014 14.7539 14.0014H20.25ZM20.25 2.99622C21.2165 2.99622 22 3.77972 22 4.74622V10.2496C22 11.2161 21.2165 11.9996 20.25 11.9996H3.75C2.7835 11.9996 2 11.2161 2 10.2496V4.74622C2 3.82804 2.70711 3.07502 3.60647 3.00202L3.75 2.99622H20.25Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.a4b058e2ea164fcb597155fe246d7069.svg";
export { ForwardRef as ReactComponent };